var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'pill',
        ("text-" + _vm.textColor),
        ( _obj = {}, _obj[("bg-" + _vm.color)] = _vm.color, _obj ),
        { 'has-icon': _vm.icon },
        _vm.shape
    ]},[(_vm.url)?_c('a',{class:[
            'pill-inner flex items-center justify-between',
            ("text-" + _vm.textColor)
        ],attrs:{"href":_vm.url}},[(_vm.icon)?_c('q-icon',{staticClass:"tag-icon",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default")],2):_c('div',{staticClass:"pill-inner flex items-center justify-between"},[(_vm.icon)?_c('q-icon',{staticClass:"tag-icon",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }